<div class="upsell-why"> 
  <div class="upsell-why__container p-4 pb-8 mx-auto justify-center items-center relative desktop:flex flex-row-reverse gap-8">

    <div class="upsell-why__wrapper w-full">
      <div class="mb-8" *ngFor="let qa of content; let i = index; trackBy: trackByFn">
        <div *ngIf="qa.question && qa.question.length > 0" [innerHTML]="qa.question"></div>
        <div *ngIf="qa.answer && qa.answer.length > 0" [innerHTML]="qa.answer"></div>
      </div>
    </div> 
  </div> 
</div>